import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncFeedbackForm = Load(
  () =>
    import(/* webpackChunkName: "feedback-form" */ './components/FeedbackForm'),
  {},
  true,
);

const RateAppRoute = (
  <Route
    key={'rate-app-feedback'}
    path={`${basePath}/rate-app/feedback`}
    element={<AsyncFeedbackForm />}
  />
);

export default RateAppRoute;
